import httpClient from '../utils/httpClient';

const API_URL = '/salary-increase';

export const createSalaryIncrease = async (data) => {
  const response = await httpClient.post(API_URL, data);
  return response;
};

export const getAllSalaryIncreases = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.status) params.append('status', filters.status);
  if (filters.type) params.append('type', filters.type);
  const qs = params.toString();
  const url = qs ? `${API_URL}?${qs}` : API_URL;
  const response = await httpClient.get(url);
  return response;
};

export const getSalaryIncreaseById = async (id) => {
  const response = await httpClient.get(`${API_URL}/${id}`);
  return response;
};

export const addEmployeesToIncrease = async (increaseId, employeeIds) => {
  const response = await httpClient.post(`${API_URL}/${increaseId}/employees`, { employeeIds });
  return response;
};

export const applySalaryIncrease = async (increaseId, updatedBy = 1) => {
  const response = await httpClient.put(`${API_URL}/${increaseId}/apply`, { updatedBy });
  return response;
};

export const cancelSalaryIncrease = async (increaseId, updatedBy = 1) => {
  const response = await httpClient.put(`${API_URL}/${increaseId}/cancel`, { updatedBy });
  return response;
};
